import styled, { css } from 'styled-components';

import Button from 'components/Button';

export const Content = styled.div`
  text-align: center;
  min-height: 260px;
  padding-bottom: 20px;
`;

export const RefreshButton = styled(Button)<{ $marginBottom?: boolean }>`
  min-width: 165px;
  float: right;

  ${({ $marginBottom }) =>
    $marginBottom &&
    css`
      margin-bottom: 16px;
    `}
`;
